// Colors are hardcoded for ConnectionDetail page styling

/**
 * WorkSection - Displays work/role information on connection detail pages
 *
 * Display Logic:
 * - Role on first line (black), Organization on second line (grey)
 * - whatIDo as separate paragraph below (black)
 * - All fields the same size (16px); color carries the hierarchy, not size
 * - All text left-aligned (detail page is a left-aligned layout)
 *
 * @param {Object} userData - User data containing work fields
 * @param {string} userData.role - Job role/title
 * @param {string} userData.organization - Organization/company name
 * @param {string} userData.whatIDo - Description of what they do
 */
export const WorkSection = ({ userData }) => {
  // Check if aboutMe is shared and has any work data
  const hasAboutMe = userData?.sharedFields?.includes('aboutMe');
  const hasRole = userData?.role;
  const hasOrganization = userData?.organization;
  const hasWhatIDo = userData?.whatIDo;

  // Only show if aboutMe is shared AND has at least one work field
  if (!hasAboutMe || (!hasRole && !hasOrganization && !hasWhatIDo)) {
    return null;
  }

  return (
    <div style={{ width: '100%' }}>
      {/* Role and Organization share ONE line — role semibold black, org grey,
          separated by a space (user, 2026-08-20). The Anon page used to join
          them with " @ "; that separator is retired and this is now the single
          rendering both detail pages use. */}
      {(hasRole || hasOrganization) && (
        <div
          style={{
            fontSize: '16px',
            fontWeight: '400',
            color: '#999999',
            textAlign: 'center',
            marginBottom: hasWhatIDo ? '12px' : '0',
          }}
        >
          {hasRole && <span style={{ fontWeight: '600', color: '#000000' }}>{userData.role}</span>}
          {hasRole && hasOrganization && ' '}
          {userData.organization}
        </div>
      )}

      {/* What they're up to — grey, left-aligned; it can run to several lines */}
      {hasWhatIDo && (
        <div
          style={{
            fontSize: '16px',
            fontWeight: '400',
            color: '#999999',
            textAlign: 'left',
          }}
        >
          {userData.whatIDo}
        </div>
      )}
    </div>
  );
};

export default WorkSection;
